import axios from 'axios'
import utils from '@/utils'
import { failureHandling } from './errorHandling'
import { getCookie } from '@/utils/cookies'
import isempty from 'lodash.isempty'
// Token参数处理函数
function dealToken (type, o) {
  if (isempty(o)) {
    o = {}
  }
  var r
  var d = utils.getQueryString('domain')
  if (!d) {
    d = process.env.DEFAULT_ORGCODE
  }
  if (type === 'POST') {
    r = {
      data: o,
      token: {
        token: getCookie(process.env.TOKEN_KEY),
        domain: d
      }
    }
    return r
  } else if (type === 'GET' || type === 'DELETE' || type === 'PUT') {
    o.token = getCookie(process.env.TOKEN_KEY)
    o.domain = d
    return o
  }
}
/*
  接口处理函数
*/
function apiAxios (method, baseURL, url, params, success, error) {
  var d = {}
  if (params instanceof FormData) { // 如果要使用formdata
    params = dealToken(method, params)
    d = {
      method: method,
      url: url,
      data: method === 'POST' ? params.data : null,
      params: (method === 'GET') ? params : params.token,
      baseURL: baseURL,
      withCredentials: false,
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  } else {
    params = dealToken(method, params)
    d = {
      method: method,
      url: url,
      data: method === 'POST' ? params.data : null,
      params: (method === 'GET') ? params : params.token,
      baseURL: baseURL,
      withCredentials: false
    }
  }
  axios(d)
    .then(function (res) {
      if (res.data.result === 'Success') {
        if (success) {
          success(res.data)
        }
      } else if (res.data.result === 'Error') {
        if (error) {
          error(res.data.message)
        } else {
          failureHandling(res.data.message)
        }
      }
    })
    .catch(function (err) {
      if (err) {
        console.log(err)
      }
    })
}

export default {
  get: function (baseURL, url, params, success, error) {
    return apiAxios('GET', baseURL, url, params, success, error)
  },
  post: function (baseURL, url, params, success, error) {
    return apiAxios('POST', baseURL, url, params, success, error)
  },
  put: function (baseURL, url, params, success, error) {
    return apiAxios('PUT', baseURL, url, params, success, error)
  },
  delete: function (baseURL, url, params, success, error) {
    return apiAxios('DELETE', baseURL, url, params, success, error)
  }
}



// WEBPACK FOOTER //
// ./src/utils/ajax.js